// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOpenOutlinedSvg from "@ant-design/icons-svg/es/asn/FolderOpenOutlined";
import AntdIcon from '../components/AntdIcon';

var FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenOutlinedSvg
  }));
};

FolderOpenOutlined.displayName = 'FolderOpenOutlined';
export default /*#__PURE__*/React.forwardRef(FolderOpenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/FolderOpenOutlined.js
// module id = 1136
// module chunks = 0